<script lang="ts">
  import { usePage } from '@inertiajs/svelte';
  import { Link } from '@inertiajs/svelte';
  import { Button } from '$lib/components/ui/button';

  const page = usePage();
  const translations = $derived((page.props as any).translations || {});
  const legal = $derived(translations.legal || {});
  const t = $derived(legal.terms_content || {});
</script>

<svelte:head>
  <title>{legal.terms_title || 'Terms of Service'} - Fentime Aurora</title>
</svelte:head>

<div class="min-h-screen bg-zinc-50 text-neutral-800 dark:bg-neutral-900 dark:text-neutral-100 p-6 md:p-12">
  <div class="max-w-3xl mx-auto space-y-8 bg-white dark:bg-neutral-800 p-8 md:p-12 rounded-xl shadow-sm border border-neutral-200 dark:border-neutral-700">
    <!-- Header -->
    <div class="border-b border-neutral-200 dark:border-neutral-700 pb-6 flex items-center justify-between">
      <div>
        <h1 class="text-3xl font-bold tracking-tight">{legal.terms_title}</h1>
        <p class="text-sm text-neutral-500 mt-2">{legal.last_updated}</p>
      </div>
      <Link href="/login">
        <Button variant="outline" size="sm">← Return</Button>
      </Link>
    </div>

    <!-- Content -->
    <div class="space-y-6 text-base leading-relaxed text-neutral-600 dark:text-neutral-300">
      <section>
        <h2 class="text-xl font-semibold text-neutral-900 dark:text-white mb-2">{t.s1_title}</h2>
        <p>{t.s1_text}</p>
      </section>

      <section>
        <h2 class="text-xl font-semibold text-neutral-900 dark:text-white mb-2">{t.s2_title}</h2>
        <p>{t.s2_text}</p>
      </section>

      <section>
        <h2 class="text-xl font-semibold text-neutral-900 dark:text-white mb-2">{t.s3_title}</h2>
        <p>{t.s3_text}</p>
      </section>
    </div>
  </div>
</div>